function slugify (string) {
  string = string.replace(/[^a-zA-Z0-9\s-]/ig, '')
  return string.replace(/\s/g, '-')
}

export default slugify
